<template>
  <span />
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, toRef, watchEffect } from 'vue'
import { useFieldView } from '@/components/field-view-next/FieldViewState'

const props = defineProps<{
  jobNumber: string | number
}>()

const jobNumberRef = toRef(props, 'jobNumber')

const { setSelectedJobNumber, setSelectedLocation, setSelectedResource, setSelectedJobNumbers } =
  useFieldView()

onMounted(() => {
  setSelectedJobNumber(props.jobNumber)
  setSelectedJobNumbers([])
  setSelectedLocation(null)
  setSelectedResource(null)
})

watchEffect(() => setSelectedJobNumber(jobNumberRef.value))

onUnmounted(() => {
  setSelectedJobNumber(null)
})
</script>

<style scoped></style>
